module.exports = __webpack_public_path__ + "static/lyricordTextWhite.24cd8ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lyricordTextWhite.png
// module id = ./src/images/lyricordTextWhite.png
// module chunks = 35783957827783